import './_components.js';
import './components/accordion.js';
import { burger } from './functions/burger.js';
AOS.init();


const canvas = document.getElementById('gameCanvas');
const ctx = canvas.getContext('2d');
const startBtn = document.getElementById('startBtn');
const restartBtn = document.getElementById('restartBtn');

// Настройки игры
const ballRadius = 20;
const platformWidth = canvas.width;
const platformHeight = canvas.height;
const ballSpeed = 5;
const platformSpeed = 2;
let gameRunning = false;

// Положение шарика
let ballX, ballY;

// Препятствия
let obstacles;
let obstacleWidth = 100;
let obstacleHeight = 20;

// Управление
let leftPressed = false;
let rightPressed = false;

// Обработчики событий для управления
document.addEventListener('keydown', (e) => {
  if (e.key === 'ArrowLeft') leftPressed = true;
  if (e.key === 'ArrowRight') rightPressed = true;
});

document.addEventListener('keyup', (e) => {
  if (e.key === 'ArrowLeft') leftPressed = false;
  if (e.key === 'ArrowRight') rightPressed = false;
});

// Функция создания препятствий
function createObstacle() {
  const x = Math.random() * (platformWidth - obstacleWidth);
  obstacles.push({ x, y: -obstacleHeight });
}

// Функция отрисовки шарика
function drawBall() {
  ctx.beginPath();
  ctx.arc(ballX, ballY, ballRadius, 0, Math.PI * 2);
  ctx.fillStyle = '#00ff00';
  ctx.fill();
  ctx.closePath();
}

// Функция отрисовки препятствий
function drawObstacles() {
  ctx.fillStyle = '#ff0000';
  obstacles.forEach(obstacle => {
    ctx.fillRect(obstacle.x, obstacle.y, obstacleWidth, obstacleHeight);
  });
}

// Функция обновления игры
function update() {
  if (!gameRunning) return;

  ctx.clearRect(0, 0, platformWidth, platformHeight);

  // Движение шарика
  if (leftPressed && ballX > ballRadius) {
    ballX -= ballSpeed;
  }
  if (rightPressed && ballX < platformWidth - ballRadius) {
    ballX += ballSpeed;
  }

  // Движение препятствий
  obstacles.forEach(obstacle => {
    obstacle.y += platformSpeed;

    // Проверка столкновений
    if (
      ballX + ballRadius > obstacle.x &&
      ballX - ballRadius < obstacle.x + obstacleWidth &&
      ballY + ballRadius > obstacle.y &&
      ballY - ballRadius < obstacle.y + obstacleHeight
    ) {
      gameOver();
    }
  });

  // Удаление препятствий, которые вышли за пределы экрана
  obstacles = obstacles.filter(obstacle => obstacle.y < platformHeight);

  // Создание новых препятствий
  if (Math.random() < 0.02) {
    createObstacle();
  }

  drawBall();
  drawObstacles();

  requestAnimationFrame(update);
}

// Функция завершения игры
function gameOver() {
  gameRunning = false;
  startBtn.style.display = "none";
  restartBtn.style.display = "block";
  alert('Game Over!');
}

// Функция старта игры
function startGame() {
  ballX = platformWidth / 2;
  ballY = platformHeight - ballRadius - 10;
  obstacles = [];
  gameRunning = true;

  startBtn.style.display = "none";
  restartBtn.style.display = "none";

  createObstacle();
  update();
}

// Кнопка старта
startBtn.addEventListener('click', startGame);

// Кнопка перезапуска
restartBtn.addEventListener('click', () => {
  startBtn.style.display = "block";
  restartBtn.style.display = "none";
});
